module.exports = __webpack_public_path__ + "static/2front-about-people-3-9c3ccc6f2e4f9550aeb661f1f04db2d1.png";